import React, { memo } from "react";
import Dialog from "./Dialog";
import Chip from "./Chip";
import Carousel from "./Carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Linkify from "linkify-react";

const ProjectDialog = ({ dialogInfo, setProjectDialogData }) => {
    return (
        <div>
            {
                dialogInfo && (
                    <Dialog>
                        <div className="flex flex-col gap-4 text-white">
                            <div className="flex justify-between gap-4 md:text-2xl font-bold">
                                <div>{dialogInfo.name}</div>
                                <div className="cursor-pointer text-2xl" onClick={() => setProjectDialogData(null)}>
                                    <FontAwesomeIcon icon={['fas', 'times']}/>
                                </div>
                            </div>
                            <div className="flex flex-col gap-4 overflow-y-auto max-h-[15vh] md:max-h-[30vh] break-words">
                                <Linkify as="p" options={{target: '_blank'}}>
                                    {dialogInfo.description}
                                </Linkify>
                                <div className="flex flex-wrap gap-1 py-2 text-primary">
                                    {
                                        dialogInfo.skills.map((skill, index) => (
                                            <Chip key={index} label={skill}/>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="flex flex-col gap-4">
                                <Carousel name={dialogInfo.name} assets={dialogInfo.assets}/>   
                            </div>
                        </div>
                    </Dialog>  
                )
            }
        </div>
    );
}

export default memo(ProjectDialog);